import React from 'react';
import { Container,Image } from 'react-bootstrap';
function Imprint(props) {
    return(
        <div style={{ margin: "0px", display: "block", color:"#233048",textAlign:"left"}}>
            <Container fluid={false}>
                <Image style={{width:"100%",marginTop:"1rem",marginBottom:"1rem"}} 
                src="https://content-us-7.content-cms.com/e06fbe62-9b29-495e-977f-be1ceb82e8f8/dxdam/cumulusAssets/JUMO-pictures/4294995232.jpg?resize=1230px:692px&crop=1230:481;0,105">

                </Image>
                <div style={{ padding: "0",margin:"0", marginBottom: "2rem", marginTop: "2rem", display: "block",
                    fontFamily: "DIN,Arial,san-serif", fontWeight: "400", lineHeight:"1.428em"}}>
                    <h1>
                     Imprint
                    </h1>
                    <p style={{ color:"#717d8a",marginTop:"1rem"}}>


                        JUMO GmbH & Co. KG</p>
                    <p style={{ color: "#717d8a" }}>Moritz-Juchheim-Straße 1</p>
                    <p style={{ color: "#717d8a",marginBottom:"1rem" }}>36039 Fulda</p>
                    
                    <p style={{ color: "#717d8a",marginTop:"2rem",marginBottom:"2rem" }}>
                        <p>Phone: +49 661 6003-0</p>
                        <p>Fax: +49 661 6003-500</p>
                        <p>E-Mail: <a href="mailto:mail@jumo.net" style={{ color: "#233048" }}>mail@jumo.net</a></p>
                        <p>Internet:<a href="https://www.jumo.net" style={{ color: "#233048" }}>www.jumo.net</a>
                        </p>
                    </p>
                    <h3 style={{marginTop:"3rem"}}>Shareholder</h3>
                    <p>M. K. JUCHHEIM GmbH</p>
                    <h3 style={{ marginTop: "3rem" }}>Executive director</h3>
                    <p>Dipl.-Ing. Bernhard Juchheim, Dipl.-Kfm. Michael Juchheim, Dipl.-Ing. Dimitrios Charisiadis</p>
                    <h3 style={{ marginTop: "3rem" }}>Place of jurisdication</h3>
                    <p>Amtsgericht Fulda</p>
                    <h3 style={{ marginTop: "3rem" }}>Company registration in the commercial register</h3>
                    <p>HRA 302 (JUMO GmbH & Co. KG)</p>
                    <h3 style={{ marginTop: "3rem" }}>Registration Number</h3>
                    <p>HRB 17 (M. K. JUCHHEIM GmbH)</p>
                    <h3 style={{ marginTop: "3rem" }}>VAT Number</h3>
                    <p>DE112411234</p>
                    <h3 style={{ marginTop: "3rem" }}>Person responsible for the content pursuant to Section 55 Para. 2 of the Broadcasting Treaty</h3>
                    <p>Christina Scheer, Moritz-Juchheim-Straße 1, 36039 Fulda, Germany</p>
                    <h3 style={{ marginTop: "3rem" }}>Note on settlement of disputes in the EU</h3>
                    <p>The European Commission provides a platform for online dispute resolution (ODR):<br/>
                        <a href="http://ec.europa.eu/consumers/odr" style={{ color: "#233048" }}>http://ec.europa.eu/consumers/odr</a> 
                        <p>You will find our email address at the top of the imprint</p>
                        </p>
                    <h3 style={{ marginTop: "3rem" }}>Liability for contents</h3>
                    <p>As a service provider, we are responsible for our own content on this website under general law,
                         pursuant to Section 7 Para. 1 of the Telemedia Act. Pursuant to Section 8 of the Telemedia Act,
                          as service providers we are not obliged to monitor submitted or saved third-party information or
                           to screen for circumstances that suggest unlawful activity. Obligations under general law to remove 
                           or block the use of information remain unaffected. However, any liability in this respect is only possible
                            from the moment that the specific legal infringement becomes known. Upon becoming aware of any such an infringement,
                         we will remove this content immediately.</p>
                    <h3 style={{ marginTop: "3rem" }}>Notice</h3>
                    <p>For reasons of better readability and without any intention of discrimination, the texts in the Career and JUMO Campus 
                        section use exclusively the male form. This means that all sexes are included.</p>
                    <h3 style={{ marginTop: "3rem" }}>References</h3>
                    <p>For the page "Living in Fulda" information of these providers was used:</p>
                    <p>Region Fulda: <a href="http://www.region-fulda.de/" style={{ color: "#233048" }}>www.region-fulda.de</a></p>
                    <p>City of Fulda: <a href="http://www.fulda.de/" style={{ color: "#233048" }}>www.fulda.de</a></p>
                    <p>Children's academy: <a href="http://www.kaf.de/" style={{ color: "#233048" }}>www.kaf.de</a></p>
                    <p>Spotlight Musicals: <a href="http://www.spotlight-musicals.de/en/" style={{ color: "#233048" }}>www.spotlight-musicals.de/en/</a></p>
                    <p>Fulda pleasure festival: <a href="http://www.fuldaer-genussfestival.de/" style={{ color: "#233048" }}>www.fuldaer-genussfestival.de</a></p>
                    <p>German Fire Brigade Museum:  <a href="http://www.dfm-fulda.de/" style={{ color: "#233048" }}>www.dfm-fulda.de/</a></p>




                </div>
            </Container>
            
        </div>
    );
}


export default Imprint;